import React, { useState, createContext, useContext, useMemo } from 'react';

const StickyBarHeightContext = createContext({
  setStickyBarHeight: () => { },
  stickyBarHeight: 0,
});

export const useStickyBarHeight = () => useContext(StickyBarHeightContext);

export const StickyBarHeightProvider = ({ children }) => {
  const [stickyBarHeight, setStickyBarHeight] = useState(0);
  const providerValue = useMemo(() => ({
    setStickyBarHeight, stickyBarHeight,
  }), [stickyBarHeight]);
  return (
    <StickyBarHeightContext.Provider
      value={providerValue}
    >
      {children}
    </StickyBarHeightContext.Provider>
  );
};
